import React from "react";
import { Question, QuestionAnswers } from "../../../Interface/Index";
import MCQQuestion from ".././components/mcq/MCQQuestion";
import DescriptiveQuestion from ".././components/descriptive/DescriptiveQuestion";
import { RadioChangeEvent } from "antd";
import CodeRenderer from ".././components/coding/CodeRenderer";
import CodingRound from ".././components/coding/CodingRound";

interface QuestionRendererProps {
  question: Question;
  questionAnswer: QuestionAnswers;
  handleQuestionAnswer: (
    e: React.ChangeEvent<HTMLTextAreaElement> | RadioChangeEvent,
    value?: string | null
  ) => void;
  isRoundFinished: boolean;
}

const renderDescriptiveQuestion = (
  question: Question,
  questionAnswer: QuestionAnswers,
  handleQuestionAnswer: (
    e: React.ChangeEvent<HTMLTextAreaElement> | RadioChangeEvent
  ) => void,
  isRoundFinished: boolean
) => (
  <DescriptiveQuestion
    question={question}
    isRoundFinished={isRoundFinished}
    questionAnswer={questionAnswer}
    onChange={handleQuestionAnswer}
  />
);

const QuestionRenderer: React.FC<QuestionRendererProps> = ({
  question,
  questionAnswer,
  handleQuestionAnswer,
  isRoundFinished,
}) => {
  const { type } = question;
  const isAnswered =
    isRoundFinished || (question.responses && question?.responses?.length > 0);

  switch (type.toLowerCase()) {
    case "mcq":
      return (
        <MCQQuestion
          isRoundFinished={isRoundFinished}
          question={question}
          handleCheck={handleQuestionAnswer}
          questionAnswer={questionAnswer}
        />
      );
    case "descriptive":
    case null:
    default:
      return renderDescriptiveQuestion(
        question,
        questionAnswer,
        handleQuestionAnswer,
        isRoundFinished
      );
    case "coding":
      return isAnswered ? (
        <CodeRenderer
          code={questionAnswer?.answer ? `${questionAnswer.answer}` : null}
        />
      ) : (
        <CodingRound question={question} onChange={handleQuestionAnswer} />
      );
  }
};

export default QuestionRenderer;
